import PropTypes from "prop-types";
import React, { forwardRef } from "react";
// @mui
import { Box, Stack, Typography } from "@mui/material";
// components
import Image from "src/components/image";
import Button from "src/components/template/button";

// ----------------------------------------------------------------------

const XBanner = forwardRef(({ variant, content, buttonText, ButtonProps }, ref) => (
    <Box
        ref={ ref } zIndex={ 1 }
        sx={ {
            position: "fixed", top: 0, display: "flex", alignItems: "center", justifyContent: "center",
            width: "100%", minHeight: "48px", py: { xs: "14px", md: "9px" }, px: { xs: "33px", md: "6px" },
            backgroundColor: theme => theme?.palette?.[ variant ]?.main ?? "white",
            zIndex: theme => theme.zIndex.appBar + 3
        } }
    >
        <Stack direction={ { xs: "column", md: "row" } } alignItems="center" m="auto" sx={ { rowGap: "10px", columnGap: "30px" } }>
            <Stack direction="row" alignItems="center" spacing="10px">
                <Image
                    src="/assets/icon/system/ic_alert_md.svg" alt="alert" width={ 20 } height={ 20 } objectFit="contain"
                    sx={ { display: { xs: "none", md: "block" } } }
                />

                { typeof content === "string" ? (
                    <Typography variant="body1" textAlign={ { xs: "center", md: "left" } } color="white">
                        { content }
                    </Typography>
                ) : (
                    content
                ) }
            </Stack>

            { Boolean(ButtonProps) && (
                <Button
                    variant="outlined" layout="adapt"
                    sx={ {
                        height: "30px",
                        "&.MuiButton-outlined": {
                            borderColor: "white",
                            backgroundColor: "transparent",
                            "&:hover": {
                                backgroundColor: "transparent"
                            }
                        }
                    } }
                    { ...ButtonProps }
                >
                    <Typography variant="caption" color="white">
                        { buttonText }
                    </Typography>
                </Button>
            ) }
        </Stack>
    </Box>
));

XBanner.propTypes = {
    variant: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]),
    buttonText: PropTypes.string,
    //
    ButtonProps: PropTypes.object
};

export default XBanner;
